// extracted by mini-css-extract-plugin
module.exports = {"input":"Form_input__34G1-","container":"Form_container__1E4Vm","form_Container":"Form_form_Container__280y3","github_info":"Form_github_info__2D75r"};